// Define a convenience method and use it like
// ready(() => {...});
var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
};

/*
 * HISTORY STATE
 * Check if window.history is supported
 */
function historyState() {
  return window.history && window.history.replaceState;
}

/*
 * GET URL PARAMETER
 * Checks for url parameter called `name`.
 */
function getParam(name) {
  if ("URLSearchParams" in window) {
    var params = new URLSearchParams(window.location.search);
    return params.get(name);
  } else {
    // Polyfill for IE11
    var params = new RegExp("[\?&]" + name + "=([^&#]*)").exec(window.location.href);
    if (params == null) {
      return null;
    } else {
      return decodeURI(params[1]) || 0;
    }
  }
}

ready(function () {
  handleFooter();
  handleNumberStepper();
  handleFilters();
  handleScrollys();
  handleCloseCartSummary();
  handleMegaMenus();
  handleTrustpilotReviewsCount();
  handleSwiperObserver();
  handleDialogClose();
  handleAnimatedNumbers();
  handleHotspotPositions();
  handleTruncatedText();
  handleExternalVideoObserver();
});
// Listen for theme editor section updates
document.addEventListener("shopify:section:load", function (event) {
  handleTabbedAccordions();
});

/*
 * FORMAT MONEY
 * Formats the passed value as money with currency symbol.
 * Referenced from https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 */
var Shopify = Shopify || {};
Shopify.money_format = "£{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/*
 * TOGGLE MOBILE NAV
 * Open/close main nav on mobile. This just applies a class
 * and the rest is done in CSS.
 */
function toggleNav(el) {
  let nav = document.querySelector("#header-nav");
  nav.classList.toggle("nav-open");
  el.classList.toggle("active");
}

/*
 * NUMBER INPUT STEPPER
 * Number stepper used for the quantity field.
 */
function handleNumberStepper() {
  let maxQty = 20;
  let minQty = 1;
  const steppers = document.querySelectorAll(".input-stepper");

  steppers.forEach(function (stepper) {
    let input = stepper.querySelector('input[type="number"]');
    let stepperButtons = stepper.querySelectorAll("button");
    let maxValue = input.getAttribute("max") !== undefined ? parseInt(input.getAttribute("max")) : maxQty;
    let minValue = input.getAttribute("min") !== undefined ? parseInt(input.getAttribute("min")) : minQty;

    stepperButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        let currentValue = parseInt(input.value);
        if (button.classList.contains("input-stepper_decrease")) {
          if (currentValue > minValue) {
            input.value = currentValue - 1;
          }
        }
        if (button.classList.contains("input-stepper_increase")) {
          if (currentValue < maxValue) {
            input.value = currentValue + 1;
          }
        }
      });
    });
  });
}

/*
 * HANDLE COLLECTION FILTERS
 */
function handleFilters() {
  document.addEventListener("change", function (event) {
    const filterCheckbox = event.target;
    if (!filterCheckbox.matches('[data-js="collectionFilters"] input[type="checkbox"]:not([class])')) {
      return;
    }
    const filterForm = filterCheckbox.closest('[data-js="collectionFilters"]');
    if (!filterForm) return;

    const parentSection = filterForm.closest(".collection-products-section");
    const formData = new FormData(filterForm);
    const params = new URLSearchParams(formData);
    const newUrl = `${filterForm.action}?${params.toString()}`;
    // Update browser URL without reload
    window.history.replaceState({}, "", newUrl);
    // Fetch content
    fetch(newUrl)
      .then((response) => response.text())
      .then((html) => {
        const content = document.createElement("div");
        content.innerHTML = html;
        // Find matching form in returned HTML
        const returnedForm = content.querySelector(`#${parentSection.id}`);
        if (!returnedForm) return;

        // Update the required page elements.
        const selectors = ["fieldset.filter-group", ".products-grid"];
        selectors.forEach((selector) => {
          const newEl = returnedForm.querySelector(selector);
          const currentEl = parentSection.querySelector(selector);
          if (newEl && currentEl) {
            currentEl.innerHTML = newEl.innerHTML;
          }
        });
        toggleProductGridPrices(parentSection.querySelector(".js--toggle-prices"));
        insertCompareButtons();
      });
  });
}

function toggleProductGridPrices(el) {
  const section = el.closest(".section");
  const grid = section.querySelector('[data-js="products-list"]');
  if (el.checked == true) {
    grid.querySelectorAll('[data-monthly-cost="true"]').forEach(function (el) {
      el.classList.remove("hidden");
    });
    grid.querySelectorAll('[data-monthly-cost="false"]').forEach(function (el) {
      el.classList.add("hidden");
    });
  } else {
    grid.querySelectorAll('[data-monthly-cost="true"]').forEach(function (el) {
      el.classList.add("hidden");
    });
    grid.querySelectorAll('[data-monthly-cost="false"]').forEach(function (el) {
      el.classList.remove("hidden");
    });
  }
}

/*
 * HANDLE SCROLLY ROWS
 * Adds interactions to the horizontally scrolling sections.
 * @attr data-scrollby="1" - The number of slides to scroll by. This data
 *                           attribute should be set on the .scrolly element.
 * Buttons can be placed manually into html: .scrolly-buttons[data-placement="manual"]
 */
function handleScrollys() {
  const scrollys = document.querySelectorAll(".scrolly");
  scrollys.forEach(function (scrolly) {
    let scrollBy = scrolly.dataset.scrollby ?? 3;
    let scrollyParent = scrolly.parentElement;
    let scrollyItem = scrolly.firstElementChild;
    if (scrolly.scrollWidth > scrollyParent.offsetWidth) {
      scrollyParent.classList.add("scrolly-container");
      if (scrolly.childElementCount > 1) {
        if (scrollyParent.querySelector('.scrolly-buttons[data-placement="manual"]')) {
          scrollyParent.querySelector('.scrolly-buttons[data-placement="manual"]').insertAdjacentHTML(
            "afterbegin",
            `
              <button type="button" class="scroll-left" disabled>
                <span>&larr;</span>
              </button>
              <button type="button" class="scroll-right">
                <span>&rarr;</span>
              </button>
            `
          );
        } else {
          scrollyParent.insertAdjacentHTML(
            "beforeend",
            `
            <div class="scrolly-buttons" data-device="desktop">
              <div class="container">
                <button type="button" class="scroll-left" disabled>
                  <span>&larr;</span>
                </button>
                <button type="button" class="scroll-right">
                  <span>&rarr;</span>
                </button>
              </div>
            </div>
          `
          );
        }
        let btnLeft = scrollyParent.querySelector(".scroll-left");
        btnLeft.addEventListener("click", function (event) {
          scrolly.scrollLeft -= scrollyItem.offsetWidth * scrollBy;
        });
        let btnRight = scrollyParent.querySelector(".scroll-right");
        btnRight.addEventListener("click", function (event) {
          scrolly.scrollLeft += scrollyItem.offsetWidth * scrollBy;
        });
        scrolly.addEventListener("scroll", function (event) {
          if (scrolly.scrollLeft > 0) {
            btnLeft.disabled = false;
          } else {
            btnLeft.disabled = true;
          }
        });
      }
    }
  });
}

/*
 * Add item to cart and display the cart summary popup.
 */
function handleAjaxAddToCart(btn) {
  let parentForm = btn.closest("form");
  // Check if there's any required fields for this form.
  if (!parentForm.checkValidity()) {
    event.preventDefault();
    parentForm.reportValidity();
    return false;
  }
  event.preventDefault();

  // Replace button text with waiting icon and disable it.
  let btnLabel = btn.innerHTML.trim();
  btn.innerHTML = `
        <svg style="margin:0 auto;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" style="shape-rendering: auto; display: block; background: none;" width="16" height="16" xmlns:xlink="http://www.w3.org/1999/xlink"><g><circle stroke-dasharray="188.49555921538757 64.83185307179586" r="40" stroke-width="15" stroke="#ffffff" fill="none" cy="50" cx="50">
          <animateTransform keyTimes="0;1" values="0 50 50;360 50 50" dur="1s" repeatCount="indefinite" type="rotate" attributeName="transform"></animateTransform>
        </circle><g></g></g></svg>`;
  btn.disabled = true;

  // Get the variant details and add to cart.
  let variantId = parentForm.querySelector('[name="id"]').value;
  let quantity = parentForm.querySelector('input[name="quantity"]').value;
  let subscriptionPrice = parentForm.querySelector('input[name="properties[Subscription Price]"]');
  let productData = {
    items: [
      {
        id: variantId,
        quantity: parseInt(quantity),
      },
    ],
    sections: ["cart-drawer", "cart-items", "cart-summary"],
  };
  // Add the parent line key if it exists, for nesting products.
  if (btn.hasAttribute("data-parent-line-key") && btn.dataset.parentLineKey !== "") {
    productData.items[0].parent_line_key = btn.dataset.parentLineKey;
  }
  // If this is a subscription, add the subscription price as a line item property.
  if (subscriptionPrice && subscriptionPrice.value !== "") {
    if (productData.items[0].properties === undefined) {
      productData.items[0].properties = {};
    }
    productData.items[0].properties["Subscription Price"] = subscriptionPrice.value;
  }
  // console.log(productData);
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(productData),
  })
    .then((response) => {
      return response.json();
    })
    .then((cart) => {
      if (document.getElementById("shopify-section-cart-drawer")) {
        document.getElementById("shopify-section-cart-drawer").outerHTML = cart.sections["cart-drawer"];
        // Check if the floater needs to be displayed before opening the cart drawer.
        if (checkAddonFloaterVisibility() == true) {
          if (document.getElementById("cart-drawer-addon-floater")) {
            document.getElementById("cart-drawer-addon-floater").style.visibility = "hidden";
          }
        }
        cartDrawer.showModal();
      }
      if (parentForm.querySelector("#js--viewcart")) {
        btn.classList.add("hidden");
        parentForm.querySelector("#js--viewcart").classList.remove("hidden");
      }
      if (document.getElementById("cart-drawer-button")) {
        // cart/add.js doesn't return the item count, so we'll just set it to 1.
        document.querySelectorAll(".cart-drawer-button").forEach((el) => {
          el.setAttribute("data-items", "1");
        });
        document.body.dataset.cartItems = true;
      }
      // Cart page sections.
      let cartItemsSection = document.querySelector('[id$="__cart-items"]');
      let cartSummarySection = document.getElementById("shopify-section-cart-summary");
      let cartAddonsSection = document.querySelector('[id$="__cart-addons"]');
      if (cartItemsSection) {
        cartItemsSection.innerHTML = cart.sections["cart-items"];
      }
      if (cartSummarySection) {
        cartSummarySection.innerHTML = cart.sections["cart-summary"];
      }
      if (cartAddonsSection) {
        updateSections(["template--20122337247320__cart-addons"]);
      }
    });
}

/*
 * Update line item quantities. Also operates the removal of a line item.
 * @param el – Current element.
 * @param redirect (bool) - If true, reloads current page.
 * @param resetAttributes (bool) - If true, resets VAT status and cart note (used for condition).
 *                                 This is done when deleting the main personal alarm from the cart.
 */
function updateCartLineItem(el, redirect = false, resetAttributes = false) {
  let key = el.dataset.key;
  let quantity = el.value;
  if (quantity !== "" && quantity >= 0) {
    let cartItemsSection = document.querySelector('[id$="__cart-items"]');
    let cartSummarySection = document.getElementById("shopify-section-cart-summary");
    let cartAddonsSection = document.querySelector('[id$="__cart-addons"]');

    // Display loader overlay.
    if (cartItemsSection !== null) {
      document.body.classList.add("vat-overlay-loader");
    }

    if (el.closest(".cart-drawer-summary_item") !== null) {
      el.closest(".cart-drawer-summary_item").style.opacity = "0.5";
    }
    let data = {
      updates: { [key]: quantity },
      sections: ["cart-drawer", "cart-items", "cart-summary"],
    };
    if (resetAttributes) {
      data.attributes = {
        "VAT Exempt": "Yes",
      };
      data.note = "";
      document.cookie = "dismissAddon=; max-age=0; path=/";
    }
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (redirect) {
          window.location.reload();
        }

        // Cart drawer updates.
        if (document.getElementById("shopify-section-cart-drawer")) {
          document.getElementById("shopify-section-cart-drawer").outerHTML = cart.sections["cart-drawer"];
          // Check if the floater needs to be displayed before opening the cart drawer.
          if (checkAddonFloaterVisibility() == true) {
            if (document.getElementById("cart-drawer-addon-floater")) {
              document.getElementById("cart-drawer-addon-floater").style.visibility = "hidden";
            }
          }
          cartDrawer.showModal();
        }
        if (cart.item_count == 0) {
          if (document.getElementById("js--addtocart")) {
            document.getElementById("js--addtocart").disabled = false;
            document.getElementById("js--addtocart").classList.remove("hidden");
            document.getElementById("js--viewcart").classList.add("hidden");
            document.getElementById("js--addtocart").innerHTML = document.getElementById("js--addtocart").dataset.label;
          }
        }
        if (document.getElementById("cart-drawer-button")) {
          document.querySelectorAll(".cart-drawer-button").forEach((el) => {
            el.setAttribute("data-items", cart.item_count);
          });
        }
        document.body.dataset.cartItems = cart.item_count > 0 ? true : false;

        // Cart page updates.
        if (cartItemsSection !== null) {
          cartItemsSection.innerHTML = cart.sections["cart-items"];
        }
        if (cartSummarySection !== null) {
          cartSummarySection.innerHTML = cart.sections["cart-summary"];
          document.body.classList.remove("vat-overlay-loader");
        }
        if (cartAddonsSection !== null) {
          updateSections(["template--20122337247320__cart-addons"]);
        }
      });
  }
}

/*
 * Close cart summary on escape keypress.
 */
function handleCloseCartSummary() {
  // Close on escape.
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      cartDrawer.close();
    }
  });
}

/*
 * HANDLE MEGAMENU THINGS
 * For desktop only. Ignore for mobile.
 */
function handleMegaMenus() {
  if (window.matchMedia("(max-width: 1024px)").matches) {
    return;
  }
  const nav = document.getElementById("header-nav");
  const details = nav.querySelectorAll("details:not(.nav-sublinks)");
  const imageLinks = nav.querySelectorAll('a[data-js="image"]');

  // Closes nav menus on escape key press. This is primarily
  // for keyboard users/accessibility.
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      nav.querySelectorAll("details:not(.nav-sublinks)[open]").forEach((detail) => {
        detail.removeAttribute("open");
      });
    }
  });

  // Handles the nav toggles, so only one menu is open at a time.
  // Also activates menu on hover (but only on non-touch devices).
  details.forEach(function (detail) {
    if (window.matchMedia("(pointer: coarse)").matches === false) {
      detail.addEventListener("mouseenter", function (event) {
        detail.open = true;
        document.body.classList.add("blur");
      });
      detail.addEventListener("mouseleave", function (event) {
        detail.open = false;
        document.body.classList.remove("blur");
      });
    }
    detail.addEventListener("toggle", function (event) {
      if (detail.open) {
        details.forEach((otherDetail) => {
          if (otherDetail !== detail && otherDetail.open) {
            otherDetail.open = false;
          }
        });
      }
      // Also blur the body.
      if (nav.querySelector("details:not(.nav-sublinks)[open]")) {
        document.body.classList.add("blur");
      } else {
        document.body.classList.remove("blur");
      }
    });
  });

  // Switches the mega-menu image when hovering over a product link.
  imageLinks.forEach((link) => {
    link.addEventListener("mouseenter", function (event) {
      let menuContent = link.closest(".nav-megamenu-content");
      let menuImage = menuContent.querySelector(".nav-megamenu-image img");
      if (link.hasAttribute("data-image") && link.dataset.image !== "") {
        menuImage.src = link.dataset.image;
      }
    });
  });
}

/*
 * FETCH SECTIONS
 * Fetches sections using the Section Rendering API, which is more reliable
 * in returning blocks compared to bundled section rendering in the Cart Ajax API.
 * https://shopify.dev/docs/api/ajax/section-rendering#request-sections
 *
 * @param sectionIds - An array of section IDs to fetch, without the "shopify-section-" prefix.
 * @param url - The URL to fetch from. Defaults to the "/".
 */
function updateSections(sectionIds, url = "/") {
  fetchSections(sectionIds, url)
    .then((sections) => {
      // console.log(sections);
      Object.entries(sections).forEach(([id, html]) => {
        const el = document.getElementById(`shopify-section-${id}`);
        if (el) el.innerHTML = html;
      });
    })
    .catch(console.error);
}

async function fetchSections(sectionIds, url = "/") {
  const res = await fetch(`${url}?sections=${sectionIds.join(",")}`);
  return res.json();
}

/*
 * TRUSTPILOT REVIEW COUNT
 * Calls Trustpilot's API and injects the review count into the page.
 */
function handleTrustpilotReviewsCount() {
  // Check if there's any snippet instances on the current page.
  const instances = document.querySelectorAll('[data-js="trustpilot-review-count"]');
  if (instances.length > 0) {
    let apiKey = instances[0].dataset.apiKey;
    let businessId = instances[0].dataset.businessId;
    if (apiKey != "" && businessId != "") {
      let params = new URLSearchParams({
        apikey: apiKey,
      });
      return fetch(`https://api.trustpilot.com/v1/business-units/${businessId}?` + params, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const fullStars = Math.floor(data.score.stars);
          const hasHalfStar = data.score.stars % 1 !== 0;
          const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
          let starsHtml = "";
          starsHtml += Array.from({ length: fullStars }, () => `<li class="trustpilot-rating-star-full"></li>`).join(
            ""
          );
          if (hasHalfStar) {
            starsHtml += `<li class="trustpilot-rating-star-half"></li>`;
          }
          starsHtml += Array.from({ length: emptyStars }, () => `<li class="trustpilot-rating-star-empty"></li>`).join(
            ""
          );
          // Create template.
          template = `
            <ol class="trustpilot-rating-stars">${starsHtml}</ol>
            <span class="trustpilot-rating-count medium">
              ${Intl.NumberFormat().format(data.numberOfReviews.total)} Service Reviews
            </span>`;

          instances.forEach((instance) => {
            instance.insertAdjacentHTML("beforeend", template);
          });
        });
    }
  }
}

/**
 * ELEMENT-IN-VIEW
 * Creates a reusable IntersectionObserver wrapper for detecting when elements
 * enter or leave the viewport.
 *
 * Designed to be used globally so multiple elements (e.g. Swiper instances,
 * animations, lazy-loaded content) can share a single observer instance.
 *
 * @param {Object} options
 * @param {number|number[]} [options.threshold=0.5]
 *   Percentage of the element that must be visible before triggering.
 *   Can be a single number or an array of thresholds.
 *
 * @param {Element|null} [options.root=null]
 *   The element used as the viewport for checking visibility.
 *   Defaults to the browser viewport.
 *
 * @param {string} [options.rootMargin='0px']
 *   Margin around the root. Can be used to trigger earlier/later
 *   (e.g. '0px 0px -20% 0px').
 *
 * @param {(el: Element, entry: IntersectionObserverEntry) => void} [options.onEnter]
 *   Callback fired when an element enters the viewport.
 *
 * @param {(el: Element, entry: IntersectionObserverEntry) => void} [options.onLeave]
 *   Callback fired when an element leaves the viewport.
 *
 * @param {boolean} [options.once=false]
 *   If true, the element will be unobserved after the first time it enters.
 *
 * @returns {{
 *   observe: (el: Element) => void,
 *   unobserve: (el: Element) => void,
 *   disconnect: () => void
 * }}
 *   An API for managing observed elements.
 *
 * @example
 * const observer = createViewportObserver({
 *   threshold: 0.5,
 *   onEnter: (el) => el.classList.add('visible'),
 *   onLeave: (el) => el.classList.remove('visible'),
 * });
 *
 * document.querySelectorAll('.fade-in').forEach(el => {
 *   observer.observe(el);
 * });
 *
 * @example
 * // Swiper usage
 * const observer = createViewportObserver({
 *   onEnter: (el) => el.swiper?.autoplay.start(),
 *   onLeave: (el) => el.swiper?.autoplay.stop(),
 * });
 */
function createViewportObserver({ threshold = 0.5, root = null, rootMargin = "0px", onEnter, onLeave, once = false }) {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        const el = entry.target;

        if (entry.isIntersecting) {
          onEnter?.(el, entry);

          if (once) {
            obs.unobserve(el);
          }
        } else {
          onLeave?.(el, entry);
        }
      });
    },
    { threshold, root, rootMargin }
  );

  return {
    observe: (el) => el && observer.observe(el),
    unobserve: (el) => el && observer.unobserve(el),
    disconnect: () => observer.disconnect(),
  };
}

/*
 * SWIPER AUTOPLAY OBSERVER.
 */
const swiperObserver = createViewportObserver({
  threshold: 0.5,
  onEnter: (el) => {
    const swiper = el.swiper;
    if (swiper) {
      swiper.autoplay.start();
      restartSwiperProgress?.(swiper); // your progress bar hook
    }
  },
  onLeave: (el) => {
    const swiper = el.swiper;
    if (swiper) {
      swiper.autoplay.stop();
    }
  },
});

function handleSwiperObserver() {
  document.querySelectorAll(".swiper.autoplay").forEach((el) => {
    swiperObserver.observe(el);
  });
}

/*
 * SWIPER PROGRESS BAR.
 * Restarts the progress bar animation when the autoplay is triggered.
 */
function restartSwiperProgress(swiper) {
  let progressFill = swiper.el.querySelector(".progress-fill");
  if (!progressFill) return;

  const activeSlide = swiper.slides[swiper.activeIndex];

  // Read per-slide delay.
  const delay = activeSlide.getAttribute("data-swiper-autoplay");

  // Reset animation.
  progressFill.classList.remove("animate");
  void progressFill.offsetWidth; // force reflow

  // Apply new duration.
  progressFill.style.animationDuration = `${delay}ms`;
  progressFill.classList.add("animate");
}

/*
 * FOOTER
 */
function handleFooter() {
  const footer = document.getElementById("site-footer");
  const menuHeadings = footer.querySelectorAll(".footer-menu-heading-block");
  menuHeadings.forEach((heading, index) => {
    heading.setAttribute("data-item", index);
    // Walk through next siblings until the next heading
    let el = heading.nextElementSibling;
    while (el && !el.classList.contains("footer-menu-heading-block")) {
      if (el.classList.contains("footer-menu-link-block")) {
        el.setAttribute("data-item", index);
      }
      el = el.nextElementSibling;
    }
    // Toggle menu on click.
    heading.addEventListener("click", function () {
      let menuIndex = this.dataset.item;
      let connectedItems = footer.querySelectorAll(`.footer-menu-block li[data-item="${menuIndex}"]`);
      connectedItems.forEach((item) => {
        item.classList.toggle("open");
      });
    });
  });
}

/*
 * DELETE ORDER COMPLETE COOKIE
 */
function clearIsOrderComplete() {
  document.cookie = "order_complete=; max-age=0; path=/;";
  window.location.href = "/cart";
}

/*
 * TOGGLE HEADER CALLBACK FORM
 */
function toggleHeaderCallbackForm() {
  const callbackForm = document.getElementById("header-callback-form");
  if (callbackForm) {
    if (callbackForm.open == true) {
      callbackForm.open = false;
    } else {
      callbackForm.open = true;
    }
  }
}

/*
 * CLOSE DIALOG ON CLICK OUTSIDE
 */
function handleDialogClose() {
  const dialogs = document.querySelectorAll("main dialog");
  dialogs.forEach((dialog) => {
    dialog.addEventListener("click", (event) => {
      const rect = dialog.getBoundingClientRect();
      const isInDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!isInDialog) {
        dialog.close();
      }
    });
  });
}

/*
 * CHECK ADD-ON FLOATER VISIBILITY
 */
function checkAddonFloaterVisibility() {
  if (document.cookie.includes("dismissAddon=")) {
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith("dismissAddon="))
      .split("=")[1];
    if (cookieValue == "true") {
      return true;
    } else {
      return false;
    }
  }
}

/*
 * ANIMATE NUMBERS
 */
function handleAnimatedNumbers() {
  // Set all numbers to 0 on page load.
  document.querySelectorAll('[data-js="animated-number"]').forEach(function (el) {
    if (Number.isInteger(parseInt(el.dataset.number))) {
      el.setAttribute("data-integer", "true");
      el.innerText = "0";
    }
  });

  // How long should we wait before animating the numbers.
  const delay = 1000;

  // Create a new IntersectionObserver object
  let observer = new IntersectionObserver(function (entries, observer) {
    for (let entry of entries) {
      // If element is in view, animate the number.
      if (entry.isIntersecting == true) {
        let counter = entry.target;
        if (counter.dataset.count == parseInt(counter.dataset.number)) {
          return;
        }

        counter.dataset.count = 0;
        const duration = 1800;

        const animateCounter = () => {
          const target = parseFloat(counter.dataset.number);
          const suffix = counter.dataset.suffix || "";
          const startTime = performance.now();

          const step = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Easing
            const eased = 1 - Math.pow(1 - progress, 3);

            const currentValue = target * eased;
            counter.dataset.count = Math.ceil(currentValue);

            const displayValue = target.toString().includes(".") ? currentValue : Math.round(currentValue);
            counter.innerText = `${numberWithCommas(displayValue)} ${suffix}`;
            if (progress < 1) {
              requestAnimationFrame(step);
            }
          };

          requestAnimationFrame(step);
        };
        setTimeout(animateCounter, delay);
      }
    }
  });

  // Listen for element in view.
  let counters = document.querySelectorAll('[data-js="animated-number"][data-integer="true"]');
  for (let counter of counters) {
    observer.observe(counter);
  }

  // Format numbers with commas
  function numberWithCommas(x) {
    if (x.toString().includes(".") == true) {
      return x.toFixed(1);
    } else {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
}

/*
 * PRODUCT HOTSPOTS
 * Displays product hotspot on FAQs and Featured Products section.
 * See sections/faqs.liquid for html structure.
 * Marker HTML:
 *   <span class="hotspot-marker" data-style="dark" data-container="element"></span>
 *   @data-style "dark" - displays dark hotspot.
 *   @data-container "element" - Uses `.hotspot-wrapper` as container width instead
 *    of global `--max-width` container.
 */
function handleHotspotPositions() {
  let containerMaxWidth = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--max-width"));

  const markers = document.querySelectorAll(".hotspot-marker");
  markers.forEach((marker) => {
    const section = marker.closest(".section");
    const cardWrapper = section.querySelector(".hotspot-card-wrapper");
    const card = section.querySelector(".hotspot-card");

    // If marker has `data-container` attribute set to "element",
    // use its container (.hotspot-wrapper) as its max-width.
    if (marker.hasAttribute("data-container") && marker.dataset.container == "element") {
      containerMaxWidth = section.querySelector(".hotspot-wrapper").offsetWidth;
    }

    if (!marker) return;

    const sectionImage = section.querySelector(".hotspot-image");
    const aspectRatio = sectionImage.dataset.aspectRatio;
    const x = sectionImage.dataset.x;
    const y = sectionImage.dataset.y;

    // Get the actual height of the image accounting
    // for the max-height set on the container.
    let actualHeight = Math.ceil(sectionImage.width / aspectRatio);
    if (actualHeight <= sectionImage.height) {
      actualHeight = sectionImage.height;
    }

    // Get the actual width of the image and adjust based
    // on the container's max-width.
    let actualWidth = sectionImage.width;
    if (sectionImage.width <= containerMaxWidth) {
      actualWidth = containerMaxWidth;
    }

    // Set the top, left positions. If top exceeds the max-height,
    // pull it back by 100px.
    let posTop = Math.round(actualHeight * (y / 100));
    let posLeft = Math.round(actualWidth * (x / 100));
    if (posTop + 75 >= sectionImage.height) {
      posTop = sectionImage.height - 100;
    }

    // Positioning the marker.
    marker.style.top = `${posTop}px`;
    marker.style.left = `${posLeft}px`;

    // Position the hotspot card if it exists.
    if (cardWrapper) {
      cardWrapper.style.top = `${posTop}px`;
      card.style.marginLeft = `calc(${x}% + 1rem)`;
    }
  });

  window.addEventListener("resize", handleHotspotPositions);
}

/*
 * Truncate text.
 * Truncates rte text to the first paragraph on mobile or desktop. The .rte
 * container should have the following attributes:
 *  - `data-truncate-desktop="true"
 *  - `data-truncate-mobile="true"
 */
function handleTruncatedText() {
  const textDesktop = document.querySelectorAll('.rte[data-truncate-desktop="true"]');
  const textMobile = document.querySelectorAll('.rte[data-truncate-mobile="true"]');
  // Adjusts text to add the "read more" button and hide
  // the remaining content if there is any.
  const adjustText = function (section) {
    let firstP = section.querySelector("p");
    let nextContent = firstP.nextElementSibling;
    if (firstP && nextContent) {
      // Inject the button.
      const button = document.createElement("button");
      button.type = "button";
      button.className = "medium underlined gradient-text";
      button.textContent = "Read more";
      button.addEventListener("click", showText);
      firstP.append(" ", button);

      // Wrap the remaining content in a hidden div.
      const wrapper = document.createElement("div");
      wrapper.className = "truncated-text hidden";
      let node = firstP.nextSibling;
      while (node) {
        const next = node.nextSibling;
        wrapper.appendChild(node);
        node = next;
      }
      section.appendChild(wrapper);
    }
  };

  // For onclick button event: displays the hidden content and removes the button.
  const showText = function () {
    event.target.closest(".rte").querySelector(".truncated-text").classList.remove("hidden");
    event.target.remove();
  };

  // Do the necessary on mobile or desktop.
  if (window.matchMedia("(min-width: 1025px)").matches) {
    textDesktop.forEach((section) => {
      adjustText(section);
    });
  } else {
    textMobile.forEach((section) => {
      adjustText(section);
    });
  }
}

/*
 * Reset External Videos.
 * Stops any external videos (those in iframes) from continuing to play by resetting the src.
 */
function _resetExternalVideos(el = null) {
  if (el !== null) {
    if (el.tagName == "IFRAME") {
      el.src = el.src;
    }
    if (el.tagName == "VIDEO") {
      el.pause();
    }
    return;
  }
  const iframes = document.querySelectorAll(
    '[data-type="external_video"] > iframe, iframe[data-type="external_video"], video'
  );
  iframes.forEach((iframe) => {
    if (iframe.tagName == "IFRAME") {
      iframe.src = iframe.src;
    }
    if (iframe.tagName == "VIDEO") {
      iframe.pause();
    }
  });
}
const externalVideoObserver = createViewportObserver({
  threshold: 0.5,
  onLeave: (el) => {
    _resetExternalVideos(el);
  },
});
function handleExternalVideoObserver() {
  const iframes = document.querySelectorAll(
    '[data-type="external_video"] > iframe, iframe[data-type="external_video"], video'
  );
  iframes.forEach((el) => {
    externalVideoObserver.observe(el);
  });
}
